import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { useLoginStore } from 'stores'

import {
  Button,
  Main,
  Heading,
} from 'components'

const Login = () => {
  const navigate = useNavigate()
  const isLoggedIn = useLoginStore(state => state.isLoggedIn)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (isLoggedIn) {
      navigate('/')
    }
  }, [isLoggedIn, navigate])

  return (
    <Main center>
      <Heading>Login</Heading>

      <p>By logging in with a Google account, you can sync your countdown timers across all your devices, and keep them backed up in your Google account.</p>
      
      <Button
        fullwidth
        onClick={() => {
          setIsLoading(true)
          window.gapi.auth2.getAuthInstance().signIn().catch(e => {
            console.error(e)
            setIsLoading(false)
          })
        }}
        isLoading={isLoading}
      >
        <svg xmlns="http://www.w3.org/2000/svg" height="1.3em" width="1.3em" viewBox="0 0 2443 2500"><path style={{ fill: 'currentColor' }} d="M1245.8,1018.7V1481h686.5c-13.8,114.9-88.6,287.9-254.7,404.2v0c-105.2,73.4-246.4,124.6-431.8,124.6c-329.4,0-609-217.3-708.7-517.7h0l0,0v0c-26.3-77.5-41.5-160.6-41.5-246.4c0-85.8,15.2-168.9,40.1-246.4v0c101-300.4,380.6-517.7,710.1-517.7v0c233.9,0,391.7,101,481.7,185.5l351.6-343.3C1863.2,123.2,1582.2,0,1245.8,0C758.6,0,337.8,279.6,133,686.5h0h0C48.6,855.4,0.1,1045,0.1,1245.7S48.6,1636,133,1804.9h0l0,0c204.8,406.9,625.6,686.5,1112.8,686.5c336.3,0,618.7-110.7,824.9-301.7l0,0h0c235.3-217.3,370.9-537,370.9-916.3c0-102.4-8.3-177.2-26.3-254.7H1245.8z"/></svg>
        <span>Login with Google</span>
      </Button>

      <p>If you choose not to log in, your countdown timers will only be saved on this device.</p>

      <Button to="/" as={Link} secondary fullwidth>Never mind</Button>
    </Main>
  )
}

export default Login